<template>
    <b-list-group v-if="dependents.length > 0 && dependents[0]['sequence'] !== 0">
        <b-list-group-item v-for="dep in dependents" :key="dep.sequence" class="flex-column align-items-start">
            <div class="d-flex justify-content-between" v-if="dep.sequence !== 0">
                <h5 class="mb-1">{{dep.firstName}} {{dep.lastName}}</h5>
                <small>{{dep.relationship | relationship}}</small>
            </div>
            <div v-if="dep.plans && dep.plans.length >0">
                <span v-for="depPlan in dep.plans" :key="depPlan.plan_code">
                    <font-awesome-icon :icon="depPlan.icon"></font-awesome-icon>&nbsp;
                </span>
            </div>
        </b-list-group-item>
    </b-list-group>
</template>

<script>
    export default {
        name: 'DependentList',
        props: ['dependents'],
        filters: {
            relationship (value) {
                switch (value) {
                    case '2':
                        return 'Spouse'
                    case '3':
                        return 'Son'
                    case '4':
                        return 'Daughter'
                    case '5':
                        return 'Other'
                }
            }
        }
    }
</script>

<style scoped>

</style>
